import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../../api/api';

/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class Permit {
  
    constructor(public api: Api) { }

    add_permit(params?:any){
        let seq = this.api.post('index.php/presensi/Permit/add', params);
        return seq;
    }

    verficationAction(params?:any){
        let seq = this.api.post('index.php/presensi/Permit/verification', params);
        return seq;
    }
}



// WEBPACK FOOTER //
// ./src/providers/presensi/permit/permit.ts